import {
  ADVANCE_SHIPPING_METHOD,
  EXPEDITE_SHIPPING_METHOD,
  SHIPPING_AMERICAS_ADVANCE_PRICE,
  SHIPPING_INTERNATIONAL_ADVANCE_PRICE,
  SHIPPING_AMERICAS_EXPEDITE_PRICE,
  SHIPPING_INTERNATIONAL_EXPEDITE_PRICE,
  BILL_TO_COUNTRY_US,
  BILL_TO_COUNTRY_CA,
} from 'utils/constants';
import round from 'lodash/round';

export const getShippingType = (method) => {
  if (method === ADVANCE_SHIPPING_METHOD) {
    return 'Advance Exchange';
  } else if (method === EXPEDITE_SHIPPING_METHOD) {
    return 'Expedite Exchange';
  } else return 'Standard';
};

export const getShippingPrice = (method, billToAddress = {}, conversionRate = 1) => {
  const isUsaOrCanada = [BILL_TO_COUNTRY_US, BILL_TO_COUNTRY_CA].includes(billToAddress.country);

  let price = 0;

  if (method === ADVANCE_SHIPPING_METHOD) {
    price = isUsaOrCanada ? SHIPPING_AMERICAS_ADVANCE_PRICE : SHIPPING_INTERNATIONAL_ADVANCE_PRICE;
  } else if (method === EXPEDITE_SHIPPING_METHOD) {
    price = isUsaOrCanada
      ? SHIPPING_AMERICAS_EXPEDITE_PRICE
      : SHIPPING_INTERNATIONAL_EXPEDITE_PRICE;
  }

  return round(price * conversionRate, 2);
};
